import { create } from 'zustand'
import type { MessagingMethodCode } from '@/domain/messagingMethods/messagingMethodsTypes'

interface ProfileUpdateState {
  newEmail: string
  newPhoneNumber?: string

  phoneErrorMessage?: string
  emailErrorMessage?: string

  phoneIsValid?: boolean

  newPhoneMessagingMethodCode?: MessagingMethodCode
  newPhoneMessagingMethodImgUrl?: string

  currentPhoneMessagingMethodCode?: MessagingMethodCode
  currentPhoneMessagingMethodImgUrl?: string

  flowType?: 'updateEmail' | 'updatePhoneNumber'
  isUpdatingEmailWithPhoneNumber?: boolean
}

interface ProfileUpdateActions {
  setProfileUpdateFormState: (
    profileFormState: Partial<ProfileUpdateState>,
  ) => void
  resetProfileUpdateFormState: () => void
}

type ProfileUpdateStore = ProfileUpdateState & ProfileUpdateActions

const initialState: ProfileUpdateState = {
  newEmail: '',
  newPhoneNumber: '',

  phoneErrorMessage: '',
  emailErrorMessage: '',

  phoneIsValid: false,

  newPhoneMessagingMethodCode: undefined,
  newPhoneMessagingMethodImgUrl: undefined,

  currentPhoneMessagingMethodCode: undefined,
  currentPhoneMessagingMethodImgUrl: undefined,

  flowType: undefined,
  isUpdatingEmailWithPhoneNumber: false,
}

export const useProfileUpdateStore = create<ProfileUpdateStore>((set) => ({
  ...initialState,
  setProfileUpdateFormState: (profileFormState) =>
    set((state) => ({
      ...state,
      ...profileFormState,
    })),
  resetProfileUpdateFormState: () => set({ ...initialState }),
}))
